import { Modal, Button } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { IDataCollectionModalProps } from "./IDataCollection";

const DataCollectionModal = (props: IDataCollectionModalProps) => {
  const { translations, hasDataToComplete, setHasDataToComplete, navigate } =
    props;
  return (
    <Modal
      title={null}
      open={hasDataToComplete}
      centered
      width={500}
      closable={true}
      footer={null}
    >
      <div className="data-collection-modal">
        <h3>
          <WarningOutlined /> {translations.informationOutdated}
        </h3>
        <p>{translations.completeOutdatedInformation}</p>
        <Button
          key="complete"
          type="primary"
          onClick={() => {
            navigate("/DataCollection");
          }}
        >
          {translations.completeData}
        </Button>
        <Button
          key="remind"
          type="default"
          onClick={() => {
            setHasDataToComplete(false);
          }}
        >
          {translations.remindMeLater}
        </Button>
      </div>
    </Modal>
  );
};

export default DataCollectionModal;
